import { KioskItems } from './KioskItems';
import { KioskOwnerCap } from '@mysten/kiosk';

export function KioskData({
  address,
  kioskId,
  kioskCap,
}: {
  address: string;
  kioskId: string;
  kioskCap: KioskOwnerCap;
}) {
  return (
    <div className="container">
      {kioskId && (
        <KioskItems
          kioskId={kioskId}
          kioskCap={kioskCap}
          address={address}
        ></KioskItems>
      )}
    </div>
  );
}
